import React from 'react';
import PropTypes from 'prop-types';

import { SingleFieldForm } from 'inside-out/components/shared/singleFieldForm';
import MagnifyingGlassIcon from 'inside-out/components/shared/icons/magnifyingGlassIcon';
import { wrapperStyle, innerWrapperStyle } from './styles';

export const CommonFilterBar = ({ placeholderText, value, onChange, onSubmit }) => (
	<div className={wrapperStyle}>
		<div className={innerWrapperStyle}>
			<SingleFieldForm
				onSubmit={onSubmit}
				value={value}
				onChange={onChange}
				placeholderText={placeholderText}
				buttonContent={<MagnifyingGlassIcon />}
				inputWidth={404}
			/>
		</div>
	</div>
);

CommonFilterBar.propTypes = {
	placeholderText: PropTypes.string,
	value: PropTypes.string,
	onChange: PropTypes.func,
	onSubmit: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/news-and-events/commonFilterBar/component.js